/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { GetSubjectsBySchoolInfoParams } from '../_model/getSubjectsBySchoolInfoParams';
import type { SuccessBodyCategoryTreeBuildDto } from '../_model/successBodyCategoryTreeBuildDto';
import type { SuccessBodyListCategoryTreeBuildDto } from '../_model/successBodyListCategoryTreeBuildDto';
import type { SuccessBodySplitCategoryTreeResponse } from '../_model/successBodySplitCategoryTreeResponse';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCategoryTreeById = (
  categoryId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyCategoryTreeBuildDto>(
    { url: `/category-trees/${categoryId}`, method: 'GET', signal },
    options,
  );
};

export const getGetCategoryTreeByIdQueryKey = (categoryId: string) => {
  return [`/category-trees/${categoryId}`] as const;
};

export const getGetCategoryTreeByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCategoryTreeByIdQueryKey(categoryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCategoryTreeById>>
  > = ({ signal }) => getCategoryTreeById(categoryId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: categoryId !== null && categoryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoryTreeById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryTreeByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoryTreeById>>
>;
export type GetCategoryTreeByIdQueryError = ErrorType<unknown>;

export function useGetCategoryTreeById<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryTreeById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryTreeById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreeById<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryTreeById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryTreeById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreeById<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCategoryTreeById<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCategoryTreeByIdQueryOptions(categoryId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCategoryTreeByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCategoryTreeByIdQueryKey(categoryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCategoryTreeById>>
  > = ({ signal }) => getCategoryTreeById(categoryId, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCategoryTreeById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetCategoryTreeByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoryTreeById>>
>;
export type GetCategoryTreeByIdSuspenseQueryError = ErrorType<unknown>;

export function useGetCategoryTreeByIdSuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreeByIdSuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreeByIdSuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCategoryTreeByIdSuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreeById>>,
  TError = ErrorType<unknown>,
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreeById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCategoryTreeByIdSuspenseQueryOptions(
    categoryId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSubjectsBySchoolInfo = (
  params: GetSubjectsBySchoolInfoParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListCategoryTreeBuildDto>(
    { url: `/category-trees/subjects`, method: 'GET', params, signal },
    options,
  );
};

export const getGetSubjectsBySchoolInfoQueryKey = (
  params?: GetSubjectsBySchoolInfoParams,
) => {
  return [`/category-trees/subjects`, ...(params ? [params] : [])] as const;
};

export const getGetSubjectsBySchoolInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSubjectsBySchoolInfoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>
  > = ({ signal }) => getSubjectsBySchoolInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubjectsBySchoolInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>
>;
export type GetSubjectsBySchoolInfoQueryError = ErrorType<unknown>;

export function useGetSubjectsBySchoolInfo<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
          TError,
          Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubjectsBySchoolInfo<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
          TError,
          Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubjectsBySchoolInfo<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSubjectsBySchoolInfo<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSubjectsBySchoolInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSubjectsBySchoolInfoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSubjectsBySchoolInfoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>
  > = ({ signal }) => getSubjectsBySchoolInfo(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetSubjectsBySchoolInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>
>;
export type GetSubjectsBySchoolInfoSuspenseQueryError = ErrorType<unknown>;

export function useGetSubjectsBySchoolInfoSuspense<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubjectsBySchoolInfoSuspense<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubjectsBySchoolInfoSuspense<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSubjectsBySchoolInfoSuspense<
  TData = Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
  TError = ErrorType<unknown>,
>(
  params: GetSubjectsBySchoolInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSubjectsBySchoolInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSubjectsBySchoolInfoSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCategoryTreesByCountry = (
  countryCode: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodySplitCategoryTreeResponse>(
    { url: `/category-trees/countries/${countryCode}`, method: 'GET', signal },
    options,
  );
};

export const getGetCategoryTreesByCountryQueryKey = (countryCode: string) => {
  return [`/category-trees/countries/${countryCode}`] as const;
};

export const getGetCategoryTreesByCountryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCategoryTreesByCountryQueryKey(countryCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCategoryTreesByCountry>>
  > = ({ signal }) =>
    getCategoryTreesByCountry(countryCode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: countryCode !== null && countryCode !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryTreesByCountryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoryTreesByCountry>>
>;
export type GetCategoryTreesByCountryQueryError = ErrorType<unknown>;

export function useGetCategoryTreesByCountry<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
          TError,
          Awaited<ReturnType<typeof getCategoryTreesByCountry>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreesByCountry<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
          TError,
          Awaited<ReturnType<typeof getCategoryTreesByCountry>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreesByCountry<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCategoryTreesByCountry<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCategoryTreesByCountryQueryOptions(
    countryCode,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCategoryTreesByCountrySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCategoryTreesByCountryQueryKey(countryCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCategoryTreesByCountry>>
  > = ({ signal }) =>
    getCategoryTreesByCountry(countryCode, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetCategoryTreesByCountrySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoryTreesByCountry>>
>;
export type GetCategoryTreesByCountrySuspenseQueryError = ErrorType<unknown>;

export function useGetCategoryTreesByCountrySuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreesByCountrySuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCategoryTreesByCountrySuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCategoryTreesByCountrySuspense<
  TData = Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
  TError = ErrorType<unknown>,
>(
  countryCode: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCategoryTreesByCountry>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCategoryTreesByCountrySuspenseQueryOptions(
    countryCode,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
